module.exports = __webpack_public_path__ + "img/375.efd4c60d.jpg";